import { RadiobuttonCard } from '@velocity/ui'
import clsx from 'clsx'
import * as React from 'react'

import { useExpandingRadioCardStyles } from './ExpandingRadioCard.styled'

interface ExpandingRadioCardGroupProps {
  label: string
  children: React.ReactNode
}

export const ExpandingRadioCardGroup: React.FC<
  ExpandingRadioCardGroupProps
> = ({ label, children }) => {
  const classes = useExpandingRadioCardStyles()

  return (
    <div className={classes.group} role="radiogroup" aria-label={label}>
      {children}
    </div>
  )
}

interface ExpandingRadioCardProps {
  testId: string
  actionName?: string
  name: string
  value: string
  title: string
  details?: React.ReactNode
  checked: boolean
  disabled?: boolean
  onChange: () => void
  children?: React.ReactNode
}

export const ExpandingRadioCard: React.FC<ExpandingRadioCardProps> = ({
  testId,
  actionName,
  children,
  checked,
  ...card
}) => {
  const classes = useExpandingRadioCardStyles()
  const expanded = checked && !!children

  return (
    <div data-e2e-component={testId} data-dd-action-name={actionName}>
      <div className={clsx(classes.card, expanded && classes.expanded)}>
        <RadiobuttonCard {...card} checked={checked} />
        {expanded && (
          <div
            className={classes.content}
            data-e2e-component={`${testId}-content`}
          >
            {children}
          </div>
        )}
      </div>
    </div>
  )
}
